import React from "react";
import { Steps } from "antd";
import { Icon } from "semantic-ui-react";
import Welcome from "../../common/Welcome";
import logo from "../../../assets/images/logo_sef.png";
import "../../../App.css";
import SignupForm from "./SignupForm";
import { Col, Container, Image, Row } from "react-bootstrap";
import PersonalInfoForm from "./PersonalInfo";
import ConfirmedPage from "./ConfirmedPage";
import { docTitle } from "../../../helpers/docTitle";
const { Step } = Steps;

const Onboard = () => {
  docTitle("Welcome - SEF");

  const [current, setCurrent] = React.useState(0);

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [
    {
      title: "Welcome",
      desc: "Welcome page",
      icon: <Icon name="pied piper hat" color="dodge blue" />,
      content: <Welcome prev={prev} next={next} current={current} />,
    },
    {
      title: "Account Details",
      desc: "Account credentials page",
      icon: <Icon name="address card" color="dodge blue" />,
      content: (
        <SignupForm
          prev={prev}
          next={next}
          current={current}
          setCurrent={setCurrent}
        />
      ),
    },
    {
      title: "Personal Details",
      desc: "Personal info page",
      icon: <Icon name="user" color="dodge blue" />,
      content: <PersonalInfoForm prev={prev} next={next} current={current} />,
    },
    {
      title: "Complete",
      icon: <Icon name="check" color="dodge blue" />,
      content: <ConfirmedPage prev={prev} next={next} current={current} />,
    },
  ];

  return (
    <Container className="pt-4 pb-4 d-flex flex-column justify-content-between">
      <Row>
        <Col className="d-flex justify-content-center">
          <Image src={logo} className="img-fluid" width={100} />
        </Col>
      </Row>
      <Row className="">
        <Col className="">
          <Steps current={current} style={{ borderColor: "#389e0d" }}>
            {steps.map((item) => (
              <Step
                key={item.title}
                title={item.title}
                description={item.desc}
                icon={item.icon}
              />
            ))}
          </Steps>
          <div className="steps-content">{steps[current].content}</div>
        </Col>
      </Row>
    </Container>
  );
};

export default Onboard;
